import { call, select, delay } from 'redux-saga/effects';
import { isPixelEnabled } from '@dbh/site-customizations-redux';
import { makeSelectLocationHref } from '@dbh/routing-redux';
import '@dbh/validation';
import { createLoggers } from '@dbh/tracking-scripts-redux';

/*
 *
 * `injectBingScript`: `@dbh/tracking-bing`.
 *
 */const injectBingScript=()=>{window.uetq=window.uetq||[];const a=()=>{const a={ti:"4056539"};// eslint-disable-next-line no-undef
a.q=window.uetq,window.uetq=new UET(a),window.uetq.push("pageLoad");},b=document.createElement("script");b.src="//bat.bing.com/bat.js",b.setAttribute("async",!0);const c=()=>{const{readyState:c}=undefined;"loaded"!==c&&"complete"!==c&&(a(),b.onload=null,b.onreadystatechange=null);};b.onload=c,b.onreadystatechange=c;const d=document.getElementsByTagName("script")[0];d.parentNode.insertBefore(b,d);};var injectBingScript$1 = injectBingScript;

/*
 *
 * Constants: `@dbh/tracking-bing`.
 *
 */const WAIT_FOR_UETQ_BING_MS=4e3;

const loggers=createLoggers();function*isBingEnabled(){return yield isPixelEnabled("bing")}/**
 * Sometimes the `bing` script (we inject it, @see `injectBingScript`) is still
 * not loaded. Wait a few seconds for it, if that’s the case.
 * @yields {Object?} .
 */function*waitForScriptToLoadIfNecessary(){const{uetq:a}=window;a||(yield delay(WAIT_FOR_UETQ_BING_MS));}/**
 * Fires the `Bing` page view event.
 * @yields {Object?} .
 */function*fireBingPixelPageView(){if(!(yield isBingEnabled()))return;yield call(waitForScriptToLoadIfNecessary);const{uetq:a}=window;if(!a)// `Bing` pixel api is not loaded yet, sadly it means that the first page
// won't be tracked.
return;const{legacyValidCustomEventKeyNames:b,validCustomEventKeyNames:c}=a,d=b||c;// `Microsoft` has changed the API, adding `legacy` to `eventKeyName`.
if(d){d.p||(d.p=1);const b=yield select(makeSelectLocationHref());a.push({p:b}),loggers.log("[dbh][bing][page-view]:",b);}}

export { fireBingPixelPageView, injectBingScript$1 as injectBingScript };
